import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ApplicationHasAgreementWarning } from "../../components/ApplicationHasAgreementWarning";
import { ApplicationCheckList } from "../../../CheckList/components/ApplicationCheckList";
import { DangerZone } from "./DangerZone";
import { ApplicationApplicantsPanel } from "./ApplicationApplicantsPanel";
import { ApplicationBasicDetailsPanel } from "./ApplicationBasicDetailsPanel";
import { ApplicationDealerVesselPanel } from "./ApplicationDealerVesselPanel";
import { ApplicationLocksPanel } from "./ApplicationLocksPanel";
import { QuoteDetailsPanel } from "./QuoteDetailsPanel";
import { Requote } from "./requote/Requote";
import { FileManagementSection } from "./FileManagementSection";
import { useApplicationContext } from "./ApplicationContext";
import { isApplicationEditable } from "../../isApplicationEditable";
import { ApplicationCompletionDatePanel } from "./ApplicationCompletionDatePanel";
import { McaPanel } from "./McaPanel";

export default function ApplicationForm() {
  const application = useApplicationContext();
  const readonly = !isApplicationEditable(application);

  return (
    <Stack spacing={5} sx={{ px: 5, pb: 5 }}>
      <Typography variant="h5">Edit Application</Typography>
      <ApplicationHasAgreementWarning application={application} />
      <ApplicationBasicDetailsPanel application={application} />
      <ApplicationLocksPanel application={application} />
      <ApplicationApplicantsPanel application={application} />
      <ApplicationDealerVesselPanel />
      <QuoteDetailsPanel application={application} />
      {readonly || <Requote application={application} />}
      <ApplicationCompletionDatePanel application={application} />
      <McaPanel application={application} />
      <FileManagementSection application={application} />
      <ApplicationCheckList application={application} />
      <DangerZone application={application} />
    </Stack>
  );
}
